module.exports = __webpack_public_path__ + "img/img3.b0753606.jpg";